import script from "./UserTimeGoalChangeDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTimeGoalChangeDialog.vue?vue&type=script&setup=true&lang=ts"

import "./UserTimeGoalChangeDialog.vue?vue&type=style&index=0&id=58bd43c8&lang=scss"

const __exports__ = script;

export default __exports__